import { render, staticRenderFns } from "./Product_discounts.vue?vue&type=template&id=c4b17a12&scoped=true&"
import script from "./Product_discounts.vue?vue&type=script&lang=js&"
export * from "./Product_discounts.vue?vue&type=script&lang=js&"
import style0 from "./Product_discounts.vue?vue&type=style&index=0&id=c4b17a12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b17a12",
  null
  
)

export default component.exports